module.exports = __webpack_public_path__ + "static/media/insta-14.f2f581bb.png";